import { AppLayout } from "@/components/app-layout/AppLayout";
import { Outlet } from "@tanstack/react-router";

export default function SidebarLayout({
  fixedSidebar,
}: {
  fixedSidebar?: boolean;
}) {
  return (
    <AppLayout fixedSidebar={fixedSidebar}>
      <Outlet />
    </AppLayout>
  );
}
